document.addEventListener("DOMContentLoaded", () => {
  const waitForGlobals = () => {
    if (!window.LoopFeatures) {
      return setTimeout(waitForGlobals, 50);
    }

    window.LoopFeatures.init();
  };

  console.log("DOM fully loaded and parsed");

  waitForGlobals();

  const observeContractContainer = () => {
    const contractContainer = document.querySelector(
      ".loop-cp-subscription-list-active-contracts-container"
    );

    if (contractContainer) {
      const existingButton = document.querySelector(
        "#loop-subscription-list-view-details-button"
      );
      if (existingButton) {
        const anchorElement = existingButton.closest("a");
        if (anchorElement && anchorElement.href) {
          window.location.href = anchorElement.href;
          return;
        }
      }

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            const subscriptionButton = document.querySelector(
              "#loop-subscription-list-view-details-button"
            );

            if (subscriptionButton) {
              const anchorElement = subscriptionButton.closest("a");

              if (anchorElement && anchorElement.href) {
                window.location.href = anchorElement.href;
              }
            }
          }
        }
      });

      observer.observe(contractContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true,
      });
    } else {
      setTimeout(observeContractContainer, 100);
    }
  };

  observeContractContainer();
});
